'use strict';

var qs = require('qs');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var qs__default = /*#__PURE__*/_interopDefault(qs);

const qsOptions = {
    encodeValuesOnly: true,
    strictNullHandling: true,
    skipNulls: true,
    allowDots: true, // Array of Objects require this setting
};
function buildUrlFromTemplate(url, queryParameters = {}, bodyParameters = {}) {
    const [urlWithoutQuery, previousQueryString] = url.split('?');
    const query = qs__default.default.parse(previousQueryString);
    let newUrl = urlWithoutQuery;
    if (queryParameters != null &&
        typeof queryParameters === 'object' &&
        !Array.isArray(queryParameters)) {
        const templateVariables = Object.keys(queryParameters).filter((k) => newUrl.includes(`{${k}}`) || newUrl.includes(`{*${k}}`));
        const queryStringVariables = Object.keys(queryParameters).filter((k) => !templateVariables.includes(k));
        if (queryStringVariables.length > 0) {
            for (const key of queryStringVariables) {
                query[key] = queryParameters[key];
            }
        }
        for (const key of templateVariables) {
            const value = queryParameters[key];
            newUrl =
                typeof value === 'object'
                    ? newUrl
                        .replace(`{${key}}`, encodeURIComponent(JSON.stringify(value)))
                        .replace(`{*${key}}`, encodeURIComponent(JSON.stringify(value)))
                    : newUrl
                        .replace(`{${key}}`, encodeURIComponent(value))
                        .replace(`{*${key}}`, value);
        }
    }
    for (const key of Object.keys(bodyParameters)) {
        if (bodyParameters[key] instanceof Object) {
            const bodyObject = bodyParameters[key];
            for (const bodyObjectKey of Object.keys(bodyObject)) {
                newUrl = bindRouteValue(newUrl, bodyObject, bodyObjectKey);
            }
        }
        else {
            newUrl = bindRouteValue(newUrl, bodyParameters, key);
        }
    }
    const newQueryString = qs__default.default.stringify(query, qsOptions);
    if (newQueryString !== '') {
        return `${newUrl}?${newQueryString}`;
    }
    return newUrl;
}
function bindRouteValue(url, object, key) {
    const value = object[key];
    const template = `{${key}}`;
    if (url.includes(template)) {
        delete object[key];
        return url.replace(template, value);
    }
    return url;
}

exports.buildUrlFromTemplate = buildUrlFromTemplate;
//# sourceMappingURL=buildUrlFromTemplate.js.map
